import React from 'react';
import { COMPARISON } from '../mock';
import { Check, X } from 'lucide-react';

export default function Compare({ onBook }) {
  return (
    <section id="compare" className="relative py-16 md:py-24 bg-gradient-to-b from-transparent via-purple-950/10 to-transparent">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="section-title-eyebrow uppercase">Compare & Choose</div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold">
            <span className="text-white">પેકેજ </span><span className="gradient-text">સરખામણી</span>
          </h2>
          <p className="mt-4 text-gray-400">Basic vs Premium — વધુ માહિતી સાથે તમને યોગ્ય પેકેજ પસંદ કરવામાં મદદ.</p>
        </div>

        <div className="card-dark overflow-hidden">
          <div className="grid grid-cols-[1.4fr_1fr_1fr] md:grid-cols-[1.6fr_1fr_1fr]">
            <div className="px-4 md:px-6 py-4 text-gray-400 text-sm font-semibold uppercase tracking-wider border-b border-purple-900/40">વિશેષતા</div>
            <div className="px-4 md:px-6 py-4 text-center text-white font-bold border-b border-purple-900/40">BASIC</div>
            <div className="px-4 md:px-6 py-4 text-center border-b border-purple-900/40" style={{background:'linear-gradient(180deg,rgba(168,85,247,.15),transparent)'}}>
              <div className="gradient-text font-extrabold">PREMIUM</div>
              <div className="text-[10px] text-pink-400 font-semibold tracking-widest">POPULAR</div>
            </div>

            {COMPARISON.map((row, i) => (
              <React.Fragment key={i}>
                <div className={`px-4 md:px-6 py-3.5 text-sm text-gray-200 ${i % 2 ? 'bg-white/[.015]' : ''}`}>{row.feature}</div>
                <div className={`px-4 md:px-6 py-3.5 text-sm text-center ${i % 2 ? 'bg-white/[.015]' : ''}`}>{renderVal(row.basic)}</div>
                <div className={`px-4 md:px-6 py-3.5 text-sm text-center ${i % 2 ? 'bg-white/[.015]' : ''}`} style={{background:'linear-gradient(180deg,rgba(168,85,247,.05),transparent)'}}>{renderVal(row.premium, true)}</div>
              </React.Fragment>
            ))}

            <div className="px-4 md:px-6 py-4 border-t border-purple-900/40" />
            <div className="px-4 md:px-6 py-4 border-t border-purple-900/40 text-center">
              <button onClick={() => onBook('basic')} className="text-sm px-4 py-2 rounded-full border border-purple-800/60 hover:border-pink-500/70 text-gray-200">Basic બુક કરો</button>
            </div>
            <div className="px-4 md:px-6 py-4 border-t border-purple-900/40 text-center" style={{background:'linear-gradient(180deg,rgba(168,85,247,.06),transparent)'}}>
              <button onClick={() => onBook('premium')} className="gradient-btn text-sm px-4 py-2 rounded-full font-semibold">Premium બુક કરો</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function renderVal(v, premium) {
  if (v === '✓') return <Check className={`w-4 h-4 mx-auto ${premium ? 'text-pink-400' : 'text-green-400'}`} />;
  if (v === '✗') return <X className="w-4 h-4 mx-auto text-gray-500" />;
  return <span className={`${premium ? 'text-white font-semibold' : 'text-gray-200'}`}>{v}</span>;
}
